<template>
  <component :is="resolveLayoutVariant">
    <!-- Кнопка установки PWA -->
<!--    <button v-if="showInstallBtn" @click="installApp" class="install-btn">-->
<!--      Установить приложение-->
<!--    </button>-->
    <router-view />
  </component>
</template>

<script>
import LayoutBlank from '@/layouts/LayoutBlank';
import LayoutContent from '@/layouts/LayoutContent';
import LayoutContentWithSidebar from '@/layouts/LayoutContentWithSidebar.vue';
import LayoutRegister from '@/layouts/LayoutRegister';

export default {
  name: 'App',
  components: {
    LayoutBlank,
    LayoutRegister,
    LayoutContent,
    LayoutContentWithSidebar,
    LayoutBase: () => import('@/layouts/LayoutBase')
  },
  data() {
    return {
      deferredPrompt: null,
      showInstallBtn: false
    };
  },
  mounted() {
    this.check_user();
    // Регистрация Service Worker
    if ('serviceWorker' in navigator) {
      window.addEventListener('load', () => {
        navigator.serviceWorker.register('/service-worker.js')
            .then(reg => console.log('Service Worker зарегистрирован', reg))
            .catch(err => console.error('Ошибка регистрации SW', err));
      });
    }
    // Обработка события beforeinstallprompt
    window.addEventListener('beforeinstallprompt', e => {
      e.preventDefault();
      this.deferredPrompt = e;
      this.showInstallBtn = true;
    });
    // Событие успешной установки
    window.addEventListener('appinstalled', () => {
      this.showInstallBtn = false;
      console.log('PWA установлено');
    });
  },
  methods: {
    installApp() {
      if (!this.deferredPrompt) return;
      this.deferredPrompt.prompt();
      this.deferredPrompt.userChoice.then(() => {
        this.deferredPrompt = null;
        this.showInstallBtn = false;
      });
    },
    check_user() {
      setTimeout(function () {
          if (this.$route.path !== '/impersonate')
        this.$store.dispatch('check_me').then(res => {
          if (!res) {
            const whiteList = [
              '/not-auth','/','/login','/register','/register/registerer','/register/region',
              '/forgot-password','/new-password','/password-code','/privacy-policy','/terms-of-use','/not-yet'
            ];
            if (!whiteList.includes(this.$route.path)) {
              this.$router.push('/not-auth');
              this.$swal.fire({
                icon: 'error',
                title: 'Sizga ruxsat berilmagan',
                showConfirmButton: false,
                timer: 1500
              });
            }
          }
        });
      }.bind(this), 10);
    }
  },
  computed: {
    resolveLayoutVariant() {
      const layout = this.$route.meta.layout;
      const token = this.$store.getters.token;
      const user = this.$store.getters.registerer;
      if (layout === 'base') return 'LayoutBase';
      if (layout === 'register') return 'LayoutRegister';
      if (layout === 'content-with-sidebar') return 'LayoutContentWithSidebar';
      if (layout === 'content') return 'LayoutContent';
      // По умолчанию или для неавторизованных
      return (layout === 'blank' || !(token && user && user.viewed && user.accepted))
          ? 'LayoutBlank'
          : 'LayoutContent';
    }
  }
};
</script>

<style>
.install-btn {
  position: fixed;
  bottom: 20px;
  right: 20px;
  z-index: 1000;
  padding: 10px 16px;
  background: #0066cc;
  color: #fff;
  border: none;
  border-radius: 4px;
}
</style>